export const MATERIAL_SYMBOLS_URL =
  "https://fonts.googleapis.com/css2?family=Material+Symbols+Outlined:opsz,wght,FILL,GRAD@20..48,100..700,0..1,-50..200";

export const requiredMaterialSymbols = [
  "menu",
  "notifications_active",
  "bedtime",
  "apps",
  "account_circle",
  "search",
  "home",
  "detector",
  "browse_activity",
  "domain",
  "admin_panel_settings",
  "manage_accounts",
  "logout",
  "expand_more",
] as const;

export function ensureMaterialSymbolsLoaded() {
  if (typeof document === "undefined") return;
  if (document.querySelector('link[data-dashboard-shell-icons="material-symbols"]')) return;

  const link = document.createElement("link");
  link.rel = "stylesheet";
  link.dataset.dashboardShellIcons = "material-symbols";
  link.href = MATERIAL_SYMBOLS_URL;
  document.head.appendChild(link);
}
